import { paths } from "config/paths";
import { useWebRouter } from "~utils/next-router/use-web-router";
import { FC, ReactNode, useEffect } from "react";
import { useAuthContext } from "~auth/contexts/auth";
import { AuthLoadingBackdrop } from "~auth/components/auth-loading-backdrop";
import { getRedirFromQuery, resolveSafeRedirOrFallback } from "~auth/helpers";

export const RedirectToPortal: FC<{ children: ReactNode }> = ({ children }) => {
	const router = useWebRouter();
	const { isLoading, isAuthenticated, authAccount } = useAuthContext();

	useEffect(() => {
		if (!isLoading && isAuthenticated && authAccount) {
			void router.push(
				resolveSafeRedirOrFallback({
					redir: getRedirFromQuery(router.query),
					fallback: paths.accountName.maps.root(authAccount.slug),
				}),
			);
		}
	}, [isLoading, isAuthenticated, authAccount, router]);

	if (isLoading || isAuthenticated) return <AuthLoadingBackdrop />;

	return children;
};
